import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import toLogin from '@/components/login/toLogin'
import login from '@/components/login/login'
import register from "@/components/login/register"
Vue.use(Router);
export default new Router({
  routes: [{
    // 拦截器拦截所有不在以下存在的路由请求, 由 toLogin 模板调用 checkLogin 方法判断请求 URL 是否已登入,
    // 未登入直接跳转到登入界面(login), 已登入则直接跳转到首页(index)
    path: '*',
    component: toLogin
  },
  {
    path: '/toLogin',
    component: toLogin,
  },
  {
    path: '/login',
    component: login,
  },
  {
    path: '/register',
    component: register,
  },
  {
    path: '/rp',
    component: () => import('@/components/login/retrievePassword'),
    meta: { requiresAuth: true }
  },
  {
    path: '/loginOut',
    component: () => import('@/components/login/loginOut'),
    meta: { requiresAuth: true }
  },
  {
    path: '/singlePointJump',
    component: resolve => require(['@/components/login/singlePointJump'], resolve),
    meta: { requiresAuth: true }
  },
  {
    path: "/index",
    component: index,
    meta: { requiresAuth: true },
    children: [{
      path: "/",
      component: () => import('@/components/commen/toHome'), // 跳转控制模板从定向到不同的首页
      meta: { requiresAuth: true },
    },
    // 自定义菜单需要绑定主菜单 ID, 也就是下面系统菜单路由中的 hasAuth, 如果不绑定, 那么非管理员用户如果直接地址输入用户管理路由是能够跳转的, 那么谁都可以修改/删除用户了
    // 自定义页签路由 ===============================================================================================
    {
      path: "/pub/temp",
      component: () => import('@/components/pub/temp'),
      // meta: {requiresAuth: true, hasAuth: ['303', '305','2']},
    },
    {
      path: "/homePage",
      component: () => import('@/components/commen/homePage'),
      meta: { requiresAuth: true, hasAuth: ['303', '305', '2'] },
    },
    {
      path: "/blank",
      component: () => import("@/components/commen/blank"),
    },
    // 外部个人信息
    {
      path: "/perfectInfo",
      component: () => import('@/components/user/outsidePersonal/perfectInfo'),
      meta: { requiresAuth: true, hasAuth: ['303'] },
    },
    {
      path: "/attestation",
      component: () => import('@/components/user/outsidePersonal/attestation_p'),
      meta: { requiresAuth: true, hasAuth: ['303'] },
    },
    {
      path: "/cup",
      component: () => import('@/components/user/outsidePersonal/rz_CUP'),
      meta: { requiresAuth: true, hasAuth: ['303'] },
    },
    {
      path: "/sesame",
      component: () => import('@/components/user/outsidePersonal/rz_zhima'),
      meta: { requiresAuth: true, hasAuth: ['303'] },
    },
    // 合同类型
    {
      path: "/viewContractType/:typeId",
      component: () => import('@/components/user/insideCompany/viewContractType'),
      meta: { requiresAuth: true, hasAuth: ['701'] },
    },
    {
      path: "/viewAncillaryFileType/:typeId",
      component: () => import('@/components/user/insideCompany/viewAncillaryFileTypes'),
      meta: { requiresAuth: true, hasAuth: ['701'] },
    },
    {
      path: "/editContractType/:typeId",
      component: () => import('@/components/user/insideCompany/editContractType'),
      meta: { requiresAuth: true, hasAuth: ['701'] },
    },
    {
      path: "/addOrUpdateAncillaryFileTypes",
      component: () => import('@/components/user/insideCompany/addOrUpdateAncillaryContractType'),
      meta: { requiresAuth: true, hasAuth: ['701'] },
    },
    {
      path: "/sign",
      component: () => import('@/components/commen/sign'),
      meta: { requiresAuth: true, hasAuth: ['504', '505', '506'] }
    },
    {
      path: '/signed',
      component: () => import('@/components/commen/signed'),
      meta: { requiresAuth: true, hasAuth: ['504', '505', '506'] }
    },
    {
      path: '/batchSigned',
      component: () => import("@/components/user/insideCompany/batch/batchSigned"),
      meta: { requiresAuth: true, hasAuth: ['504', '505', '506'] }
    },
    // 用户管理
    {
      path: "/addPersonPage",
      name: "addPersonPage",
      component: () => import('@/components/user/admin/addPerson'),
      meta: { requiresAuth: true, hasAuth: ['301'] },
    },
    {
      //用户组管理
      path: "/user/group",
      component: () => import("@/components/user/insideCompany/userGroupManagement"),
      meta: { requiresAuth: true },
    },
    {
      //批量归档合同
      path: "/batchArchivedFile",
      component: () => import("@/components/user/insideCompany/batch/batchArchivedFile"),
      meta: { requiresAuth: true },
    },
    {
      path: "/updatePersonalInfoPage/:userId",
      component: () => import('@/components/user/admin/updatePersonalInfo'),
      meta: { requiresAuth: true, hasAuth: ['301'] },
    },
    // 外部企业认证
    {
      path: "/completeEnterpriseInfo/:orgId",
      component: () => import('@/components/user/outsideCompany/perfectInfo_e'),
      meta: { requiresAuth: true, hasAuth: ['305'] },
    },
    {
      path: "/waitAudit",
      component: () => import('@/components/user/outsideCompany/attestation_e'),
      meta: { requiresAuth: true, hasAuth: ['305'] },
    },
    // =======================================================================
    // 合同信息
    {
      path: "/viewContractInformation",
      component: () => import('@/components/user/insideCompany/viewContractInformation'),
      meta: { requiresAuth: true, },
    },
    {
      path: "/revocationContract",
      component: () => import('@/components/user/insideCompany/revocationContract'),
      meta: { requiresAuth: true, },
    },
    {
      //新增附属文件
      path: "/newSubsidiaryFile",
      component: () => import("@/components/user/insideCompany/newSubsidiaryFile"),
      meta: { requiresAuth: true, },
    },
    {
      //新增附属文件->选择附属合同模板
      path: "/newSubsidiaryFileSelectTemp",
      component: () => import("@/components/user/insideCompany/newSubsidiaryFileSelectTemp"),
      // meta: {requiresAuth: true,},
    },
    {
      //合同模板详情
      path: "/viewContractParticlars",
      component: () => import("@/components/user/insideCompany/viewContractParticlars"),
      meta: { requiresAuth: true, },
    },
    {
      //新建/修改附属合同
      path: "/viewContractAffiliateTemplate",
      component: () => import("@/components/user/insideCompany/viewContractAffiliateTemplate"),
      meta: { requiresAuth: true, },
    },
    {
      //用户审核
      path: "/contractAssessor",
      component: () => import("@/components/user/insideCompany/contractAssessor"),
      meta: { requiresAuth: true, },
    },
    {
      //设置签约人
      path: "/settingUpContractors",
      component: () => import("@/components/user/insideCompany/settingUpContractors"),
      meta: { requiresAuth: true, },
    },
    {
      //字典修改路由
      path: "/dictModification",
      component: () => import("@/components/user/admin/dictModification"),
      meta: { requiresAuth: true, hasAuth: ['401'] },
    },
    {
      //合同作废页面
      path: "/cancellationContract",
      component: () => import("@/components/user/insideCompany/cancellationContract"),
      meta: { requiresAuth: true },
    },
    {
      //合同备案详情页面
      path: "/contractFileRecord",
      component: () => import("@/components/user/insideCompany/contractFileRecord"),
      meta: { requiresAuth: true },
    },
    {
      //在编合同按钮（创建合同）
      path: "/compilationContractModification",
      component: () => import("@/components/user/insideCompany/compilationContractModification"),
      meta: { requiresAuth: true },
    },
    {
      //机构管理
      path: "/org/management",
      component: () => import("@/components/user/insideCompany/organizationalManagement"),
      meta: { requiresAuth: true },
    },
    //员工管理
    {
      path: "/staff/management",
      component: () => import("@/components/user/insideCompany/staffManagement"),
      meta: { requiresAuth: true }
    },
    //企业员工信息
    {
      path: "/staff/managementInfo",
      component: () => import("@/components/user/insideCompany/staffManagementInformation"),
      meta: { requiresAuth: true }
    },
    //企业员工修改和新增
    {
      path: "/staff/Revise",
      component: () => import("@/components/user/insideCompany/staffInformationRevise"),
      meta: { requiresAuth: true }
    },
    {
      path: "/setting/management",
      component: () => import("@/components/user/admin/settingManagement"),
      meta: { requiresAuth: true }
    },
    {
      path: "/businessitem/management", //业务数据项管理
      component: () => import("@/components/commen/businessItem")
    },
    {
      path: "/user/management", // 用户管理
      component: () => import('@/components/user/admin/userManage'),
      meta: { requiresAuth: true, hasAuth: ['301'] },
    },
    {
      path: "/user/audit", // 用户审核列表
      component: () => import('@/components/user/admin/userAuditList'),
      meta: { requiresAuth: true, hasAuth: ['302'] },
    },
    {
      path: "/user/detail", // 用户信息
      component: () => import('@/components/commen/personalInfo'),
      meta: { requiresAuth: true, hasAuth: ['303'] },
    },
    {
      path: "/user/chgPwd", // 修改密码
      component: () => import('@/components/commen/updatePassword'),
      meta: { requiresAuth: true, hasAuth: ['304'] },
    },
    {
      path: "/user/corpInfo", // 企业用户信息
      component: () => import('@/components/user/outsideCompany/companyInfo'),
      meta: { requiresAuth: true, hasAuth: ['305'] },
    },
    {
      path: '/role/management', // 角色管理
      component: () => import('@/components/user/admin/roleManage'),
      meta: { requiresAuth: true, hasAuth: ['401'] },
    },
    {
      path: "/dict/management", // 字典管理
      component: () => import('@/components/user/admin/dictManage'),
      meta: { requiresAuth: true, hasAuth: ['402'] },
    },
    {
      path: "/contract/setup", // 字典管理
      component: () => import('@/components/user/admin/contractSetPage'),
      meta: { requiresAuth: true },
    },
    {
      path: "/menu/management", // 菜单管理
      component: () => import('@/components/user/admin/menuManage'),
      meta: { requiresAuth: true, hasAuth: ['403'] },
    },
    {
      path: "/contact/code", // 合同编号
      component: () => import('@/components/user/admin/contractNumberList'),
      meta: { requiresAuth: true, hasAuth: ['404'] },
    },
    {
      path: "/contact/auth", // 合同权限设置
      component: () => import("@/components/user/admin/contractPrivilegeSetting"),
      meta: { requiresAuth: true, hasAuth: ['405'] },
    },
    {
      path: "/contact/statistical", // 合同统计
      component: () => import('@/components/user/admin/contractStatistics'),
      meta: { requiresAuth: true, hasAuth: ['406'] },
    },
    {
      path: "/sys/log", // 系统日志
      component: () => import('@/components/user/admin/logManage'),
      meta: { requiresAuth: true, hasAuth: ['407'] },
    },
    {
      path: '/contact/type/management', // 合同类型列表
      component: () => import('@/components/user/insideCompany/contractTypeList'),
      meta: { requiresAuth: true, hasAuth: ['701'] },
    },

    {
      path: "/contact/template/management", // 合同模板管理
      component: () => import('@/components/user/insideCompany/contractTemplateList'),
      meta: { requiresAuth: true, hasAuth: ['702'] },
    },

    {
      path: '/contact/create', // 新建合同
      component: () => import('@/components/user/insideCompany/createContract'),
      meta: { requiresAuth: true, hasAuth: ['503'] },
    },
    {
      path: '/contact/createContractInfo', // 新建合同信息确认
      component: () => import('@/components/user/insideCompany/createContractInfo'),
      meta: { requiresAuth: true },
    },
    {
      path: '/contact/waitGenerate', // 在编合同
      component: () => import('@/components/user/insideCompany/compilationContract'),
      meta: { requiresAuth: true, hasAuth: ['504'] },
    },
    {
      path: '/contact/waitSign', // 待办合同
      component: () => import('@/components/user/insideCompany/pendingContract'),
      meta: { requiresAuth: true, hasAuth: ['505'] },
    },
    {
      path: '/contact/waitSigning', // 在签合同
      component: () => import('@/components/user/insideCompany/signingContract'),
      meta: { requiresAuth: true, hasAuth: ['506'] },
    },
    {
      path: '/contact/signed', // 未归档合同
      component: () => import('@/components/user/insideCompany/contractFiling'),
      meta: { requiresAuth: true, hasAuth: ['507'] },
    },
    {
      path: '/contact/archived', // 已归档合同
      component: () => import('@/components/user/insideCompany/filedContractList'),
      meta: { requiresAuth: true, hasAuth: ['508'] },
    },
    {
      path: '/contact/find', // 合同查询
      component: () => import('@/components/user/insideCompany/selectContract'),
      meta: { requiresAuth: true, hasAuth: ['509'] },
    },
    {
      path: '/contact/record', // 合同备案
      component: () => import('@/components/user/insideCompany/contractRecordList'),
      meta: { requiresAuth: true, hasAuth: ['510'] },
    },
    //批量合同管理
    {
      path: '/contact/batch/create', // 批量创建 选择合同类型及模板
      component: () => import("@/components/user/insideCompany/batchCreationSelectType"),
      meta: { requiresAuth: true, hasAuth: ['803'] },
    },
    {
      path: '/contact/batch/createContractInfo', // 批量创建 创建进程
      component: () => import("@/components/user/insideCompany/batchCreationProcess"),
      meta: { requiresAuth: true, hasAuth: ['803'] },
    },
    {
      path: '/contact/batch/waitGenerate', // 批量创建 在编合同
      component: () => import("@/components/user/insideCompany/batchCompilationContract"),
      meta: { requiresAuth: true, hasAuth: ['804'] },
    },
    {
      path: '/batchCompilationContractModification',
      component: () => import("@/components/user/insideCompany/batchCompilationContractModification"),
      meta: { requiresAuth: true },
    },
    {
      path: '/contact/batch/waitSign', // 批量创建 待办合同
      component: () => import("@/components/user/insideCompany/batchPendingContract"),
      meta: { requiresAuth: true, hasAuth: ['805'] },
    },
    {
      path: '/contact/batch/batchSignature', //
      component: () => import("@/components/user/insideCompany/batchSignature"),
      meta: { requiresAuth: true },
    },
    {
      path: '/contact/batch/batchContractInfo',
      component: () => import("@/components/user/insideCompany/batchContractInfo"),
      meta: { requiresAuth: true },
    },
    {
      path: '/contact/batch/find', // 批量创建 合同查询
      component: () => import("@/components/user/insideCompany/batchSelectContract"),
      meta: { requiresAuth: true, hasAuth: ['806'] },
    },
    {

      path: '/batchviewInformation', // 批量页面 ->查看 ->查看
      component: () => import("@/components/user/insideCompany/batch/batchviewInformation"),
      meta: { requiresAuth: true },
    },
    {
      path: '/batchRevocationContract', // 批量页面 ->撤销页面
      component: () => import("@/components/user/insideCompany/batch/batchRevocationContract"),
      meta: { requiresAuth: true }
    },
    {
      path: '/batchViewSignatureProcess', // 批量页面 ->查看子签章流程
      component: () => import("@/components/user/insideCompany/batch/batchViewSignatureProcess"),
      meta: { requiresAuth: true }
    },
    {
      path: '/batchContractAssessor', // 批量页面 ->审核流程
      component: () => import("@/components/user/insideCompany/batch/batchContractAssessor"),
      meta: { requiresAuth: true }
    },
    {
      path: '/batchSign', // 批量页面 ->查看签章
      component: () => import("@/components/user/insideCompany/batch/batchSign"),
      meta: { requiresAuth: true }
    },
    {
      //签章定位
      path: "/signPos",
      component: () => import("@/components/commen/signPos"),
      meta: { requiresAuth: true }
    },
    {
      //签章完成
      path: "/signPosed",
      component: () => import("@/components/commen/signPosed"),
      meta: { requiresAuth: true }
    },
    {
      //签章完成
      path: "/test",
      component: () => import('@/components/commen/test'),
      meta: { requiresAuth: true }
    },
    {
      //设置签署
      path: "/signSet",
      component: () => import("@/components/user/admin/signatureSettings/signSet"),
      meta: { requiresAuth: true }
    },
    {
      //个人实名
      path: "/personalRN",
      component: () => import("@/components/user/realName/personalRN"),
      meta: { requiresAuth: true }
    },
    {
      path: "/enterpriseRN",
      component: () => import("@/components/user/realName/enterpriseRN"),
      meta: { requiresAuth: true }
    },
    {
      path: "/enterpriseRNRemitMoney",
      component: () => import("@/components/user/realName/enterpriseRNRemitMoney"),
      meta: { requiresAuth: true }
    },
    {
      path: "/enterpriseRNOrgAccount",
      component: () => import("@/components/user/realName/enterpriseRNOrgAccount"),
      meta: { requiresAuth: true }
    },
    {
      path: "/enterpriseRNUnionPay",
      component: () => import("@/components/user/realName/enterpriseRNUnionPay"),
      meta: { requiresAuth: true }
    },
    {
      path: "/enterpriseRNSuccess",
      component: () => import("@/components/user/realName/enterpriseRNSuccess"),
      meta: { requiresAuth: true }
    },
    {
      //批量创建合同
      path: "/batchCreateContract",
      component: () => import("@/components/user/insideCompany/batchCreateContract/batchCreateContract"),
      meta: { requiresAuth: true }
    },
    {
      path: '/projectMan', // 项目管理
      component: () => import('@/components/user/admin/project/projectMan'),
      meta: { requiresAuth: true }
    },
    {
      path: '/projectTypeMan', // 项目分类管理
      component: () => import('@/components/user/admin/project/projectTypeMan'),
      meta: { requiresAuth: true }
    },
    {
      path: '/projectAdd', // 项目新增
      component: () => import('@/components/user/admin/project/projectAdd'),
      meta: { requiresAuth: true }
    },
    {
      path: '/projectUpdate', // 项目修改
      component: () => import('@/components/user/admin/project/projectUpdate'),
      meta: { requiresAuth: true }
    },
    {
      path: '/projectTypeAdd', // 项目分类新增
      component: () => import('@/components/user/admin/project/projectTypeAdd'),
      meta: { requiresAuth: true }
    },
    {
      path: '/projectTypeUpdate', // 项目分类修改
      component: () => import('@/components/user/admin/project/projectTypeUpdate'),
      meta: { requiresAuth: true }
    },
    {
      //关键字签章定位
      path: "/signkeyWords",
      component: () => import("@/components/commen/signkeyWords"),
      meta: { requiresAuth: true }
    },
    {
      //签章完成
      path: "/signkeyWordsed",
      component: () => import("@/components/commen/signkeyWordsed"),
      meta: { requiresAuth: true }
    },
    {
      // 设置签章位置
      path: "/setSignPosition",
      component: () => import('@/components/user/insideCompany/setSignPosition'),
      meta: { requiresAuth: true }
    },
    {
      //待设置合同
      path: "/pendingSetContract",
      component: () => import('@/components/user/insideCompany/pendingContract/pendingSetContract'),
      meta: { requiresAuth: true }
    },
    {
      // 权限管理
      path: "/oauthManage",
      component: () => import('@/components/user/admin/oauthManage'),
      meta: { requiresAuth: true }
    },
    {
      // 权限管理
      path: "/physicalSealAuditDetails",
      component: resolve => require(['@/components/user/insideCompany/pendingContract/physicalSealAuditDetails'], resolve),
      meta: { requiresAuth: true }
    },
    {
      // 权限管理
      path: "/cloudSignPos",
      component: resolve => require(['@/components/user/insideCompany/pendingContract/cloudSignPos'], resolve),
      meta: { requiresAuth: true }
    },
    {
      // 权限管理
      path: "/user/sealmanage",
      component: resolve => require(['@/components/user/sealmanage/sealmanage'], resolve),
      meta: { requiresAuth: true }
    }
    ]
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js